// @flow

import React from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

import { comparisonValues } from "src/constants/charts";
import Line from "./Line";
import Column from "./Column";
import Area from "./Area";
import Rate from "./Rate";

type Props = {
  id: string,
  chartDetails: Object,
  position: number,
  plotType: Function,
  setChartDetails: Function,
};

function SortableItem({
  id,
  position,
  chartDetails,
  setChartDetails,
  plotType,
}: Props) {
  const { listeners, setNodeRef, setActivatorNodeRef, transform, transition } =
    useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  const commonProps = {
    key: id,
    id,
    chartDetails,
    position,
    setChartDetails,
    rowRef: setNodeRef,
    style,
    dragHandleRef: setActivatorNodeRef,
    dragHandleListeners: listeners,
  };

  if (plotType === comparisonValues.line) {
    return <Line {...commonProps} />;
  }

  if (plotType === comparisonValues.area) {
    return <Area {...commonProps} />;
  }

  if (plotType === comparisonValues.column) {
    return <Column {...commonProps} />;
  }

  if (plotType === comparisonValues.rate) {
    return <Rate {...commonProps} />;
  }

  return null;
}

export default SortableItem;
